import request from "@/utils/request";

// 获取题库列表
export function getQuestionList(data) {
  return request({
    url: "local_exam_search_question",
    method: "GET",
    params: data,
  });
}
// 添加试题
export function getAddQuestion(data) {
  return request({
    url: "local_exam_create_question",
    method: "GET",
    params: data,
  });
}
// 编辑试题
export function getEidtQuestion(data) {
  return request({
    url: "local_exam_edit_question",
    method: "GET",
    params: data,
  });
}
// 删除试题
export function getDelQuestion(data) {
  return request({
    url: "local_exam_delete_question",
    method: "GET",
    params: data,
  });
}
// 导入试题
export function getImportQuestion(data) {
  var category_id = data.category_id;
  var is_check = data.is_check;
  var type = data.type;
  var fileData = data.file;
  return request({
    url: "local_exam_import_question",
    method: "POST",
    params: { category_id, is_check, type },
    data: fileData,
  });
}
// ----------------------------
// 批量审核
export function batchAudit(data) {
  return request({
    url: "local_exam_check_question",
    method: "GET",
    params: data,
  });
}

// -----------------------------------
// 获取试题分类
export function getQuestionClassify(data) {
  return request({
    url: "local_exam_search_category",
    method: "GET",
    params: data,
  });
}
// 添加试题分类
export function getAddQuestionClassify(data) {
  return request({
    url: "local_exam_create_category",
    method: "GET",
    params: data,
  });
}
// 删除试题分类
export function getDelQuestionClassify(data) {
  return request({
    url: "local_exam_delete_category",
    method: "GET",
    params: data,
  });
}
// 编辑试题分类
export function getEditQuestionClassify(data) {
  return request({
    url: "local_exam_edit_category",
    method: "GET",
    params: data,
  });
}
// 导入试题分类
export function getImportQuestionClassify(data) {
  return request({
    url: "local_exam_import_category",
    method: "POST",
    data,
  });
}
// 查看试题详情
export function getQuestionDetail(data) {
  return request({
    url: "local_exam_read_question",
    method: "get",
    params: data,
  });
}
// 通用上传接口
export function generalUpload(data) {
  var fileData = data.file;
  return request({
    url: "local_exam_general_upload",
    method: "POST",
    data: fileData,
  });
}
// 导出试题接口
export function downloadQuestion(data) {
  return request({
    method: "GET",
    params: data,
  });
}
